<template id="projectsTmpl">
	
	<v-card>
		
		<v-card-text v-if="orgitem != null">
		
			<v-btn class="button-main" v-on:click="openNewProject()"><v-icon left dark>add</v-icon>{{ $t('btn.addProject')}}</v-btn>

			<v-data-table :headers="headersProjects" :items="projectList" :no-data-text="$t('err.noelem')" :loading="$root.loading" class="mt-2 elevation-1">
				<template v-slot:body="{ items }">
					<tbody>
					<tr v-for="item in items" :key="item.id" >
						<td class="font-weight-bold">{{$root.findTranslationInList(item.project_name)}}</td>
						<td class="font-weight-bold">{{ $t('lbl.status_'+ item.state)}}</td>
						<td width="20%" class="text-right">
							<v-tooltip top> 
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										class="button-secondary ma-1" fab small depressed 
										v-bind="attrs"
										v-on="on"  
										@click="$root.goToPage('/appcommerciale/project/' + orgitem.organization_id + '/' + item.project_id)">
										<v-icon v-if="item.state != constantValueStatusDone">create</v-icon>
										<v-icon v-else>search</v-icon>
									</v-btn>
								</template>
								<span v-if="item.state != constantValueStatusDone">{{ $t('btn.edit')}}</span>
								<span v-else>{{ $t('btn.details')}}</span>
							</v-tooltip>		

							<v-tooltip top v-if="item.state != constantValueStatusDone"> 		
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										class="button-secondary ma-1" fab small depressed 
										v-bind="attrs"
										v-on="on"   
										v-on:click="deleteProject(item.project_id)"
									><v-icon>delete</v-icon></v-btn>
								</template>
								<span>{{ $t('btn.delete')}}</span>
							</v-tooltip>

						</td>
					</tr>
					</tbody>
				</template>
			</v-data-table>
			
			<!-- FORM NEW PROJECT START -->
			<v-dialog v-model="dlgCreateProjectIsOpen" v-if="newProject != null" persistent max-width="500px" >
				<v-form ref="newProjectFrm" v-model="validNewProjectFrm" lazy-validation>
					<v-card>
						<v-card-title><span class="headline">{{ $t('lbl.newProject')}}</span></v-card-title>

						<v-card-text>
							<v-layout row wrap>
								<v-flex xs12><strong>{{ $t('lbl.lang_it_IT')}}</strong></v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="newProject.project_name.it_IT" :rules="nameRules" :label="$t('lbl.projectName')" required></v-text-field></v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="newProject.project_description.it_IT" :rules="descriptionRules" :label="$t('lbl.projectDescription')" required></v-text-field></v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12><strong>{{ $t('lbl.lang_en_US')}}</strong></v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="newProject.project_name.en_US" :rules="nameRules" :label="$t('lbl.projectName')" required></v-text-field></v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="newProject.project_description.en_US" :rules="descriptionRules" :label="$t('lbl.projectDescription')" required></v-text-field></v-flex>
							</v-layout>
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn class="button-main ma-1" v-on:click="closeNewProject()" ><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
							<v-btn class="button-main ma-1" v-on:click="createNewProject()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>

			</v-dialog>
			<!-- FORM NEW PROJECT END -->

		</v-card-text>

		<v-card-text v-else>
			{{ $t('lbl.wait')}}
		</v-card-text>

	</v-card>



</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		projectList: [],
		headersProjects: [
			{ text: i18n.t('lbl.projects'), align: 'left', value: 'name'},
			{ text: i18n.t('lbl.orgStatusWorkflow'), align: 'left', value: 'status_workflow_lbl'},
			{ text: '', align: 'center'}
		],
		dlgCreateProjectIsOpen: false,
		validNewProjectFrm: false,
		nameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		descriptionRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		newProject: null,
		constantValueStatusDone: ''
	}),
	props: ['orgitem'],
	created()
	{
		
	},
	mounted() 
	{
		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_LOAD_PROJECT_LIST, (orgId) => {
			this.loadProjectListById(orgId);
		});
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.headersProjects = [
				{ text: i18n.t('lbl.projects'), align: 'left', value: 'name'},
				{ text: i18n.t('lbl.orgStatusWorkflow'), align: 'left', value: 'status_workflow_lbl'},
				{ text: '', align: 'center'}
			];
		});

		this.newProject = this.getEmptyProject();
		
		//=== APPOGGIO LE COSTANTI
		this.constantValueStatusDone = constants.PRJ_STATUS_DONE;

		// LANCIO IL CARICAMENTO COMUNQUE
		// PUO ESSERE CHE VENGA CARICATO IL PROGETTO PRIMA CHE SIA FATTO IL CREATED
		this.loadProjectList();
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_LOAD_PROJECT_LIST);
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	methods: {
		loadProjectListById(orgId)
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + orgId + '/projects';
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadProjectList, 'err.loadingPrjs');
		}, 
		loadProjectList()
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.orgitem.organization_id + '/projects';
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadProjectList, 'err.loadingPrjs');
		}, 
		callbackLoadProjectList(responseData) 
		{
			if(!this.isEmptyObj(responseData) && !this.isEmptyObj(responseData.projects) && Array.isArray(responseData.projects))
			{
				this.projectList = responseData.projects;
			}
			// NON DEVO DARE ERRORE SE VUOTO
			//else 
			//{
			//	this.$root.setDialogMsg(i18n.t("err.loadingPrjs"));
			//}
		},
		openNewProject()
		{
			this.dlgCreateProjectIsOpen = true;
		},
		closeNewProject()
		{
			this.dlgCreateProjectIsOpen = false;
		},
		createNewProject() 
		{
			if (this.$refs.newProjectFrm.validate()) 
			{
				var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.orgitem.organization_id + '/projects';
				this.$root.genericPostAuthenticatedCallEngine(endpoint2go, this.newProject, this.callbackcreateNewProject, 'err.savingPrj');		
			}
		},
		callbackcreateNewProject(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.newProject = this.getEmptyProject();
				this.dlgCreateProjectIsOpen = false;
				this.loadProjectList();
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.savingPrj"));
			}
		},
		deleteProject(prjId)
		{
			if(!this.isEmptyString(prjId))
			{
				if(confirm(i18n.t('lbl.project') + " " +prjId + " - " + i18n.t('msg.confirmDelete')))
				{	
					var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.orgitem.organization_id + '/projects/' + prjId;
					this.$root.genericDeleteAuthenticatedCallEngine(endpoint2go, this.callbackDeleteProject, 'err.deletePrj');	
				}	
			}
		},
		callbackDeleteProject(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.loadProjectList();
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.deletePrj"));
			}
		}	
	}
}
</script>